/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../lib/State";
import log from "../lib/log";
import pr from "../lib/pr";
import CenterSelect from "./CenterSelect";
import MemberSearch from "./MemberSearch";
import {
  Select,
  MenuItem,
  AppBar,
  Toolbar,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormLabel,
  Box,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { ko } from "date-fns/locale";
import moment from "moment";
import ProductSearch from "./ProductSearch";
import { lightGreen } from "@mui/material/colors";
import styled from "@emotion/styled";
import RefundCouponDialog from "./RefundCouponDialog";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Container = styled(Box)`
  padding: 10px;
`;

const CouponContainer = styled(Box)`
  display: flex;
  margin-top: 10px;
  align-items: center;
`;

// 등록하기 팝업
function OrderAdd(props) {
  const { login, onCloseAddPop, tcidParent } = props;
  const token = localStorage.getItem("token");
  const [coupon_name, setCouponName] = useState("");
  const [open_coupon_dialog, setOpenCouponDialog] = useState(false); // 쿠폰찾기 대화창
  const [coupon_seq, setCouponSeq] = useState(0); // 쿠폰발행번호
  const [mb_name, setMbName] = useState('');

  const onSubmit = async () => {
    let result = await axios.post(configState.api + "/gympass_admin/refund_add", {
      token: token,
      cid: login.cid,
      level: login.level,
      mcd: login.mcd,
      tcid : 'CID00000009',
      coupon_seq: coupon_seq,
    });

    if(result.data.success === 0) {
      Swal.fire('Error',result.data.msg);
      return;
    }
    else {
      onCloseAddPop();
    }
  }

  return (
    <Box>
      {/* 쿠폰찾기 팝업 */}
      <RefundCouponDialog
        login={login}
        open={open_coupon_dialog}
        setOpen={setOpenCouponDialog}
        setCouponName={setCouponName}
        setCouponSeq={setCouponSeq}
        setMbName={setMbName}
      />

      <Container>

        {/* 쿠폰명 */}
        <CouponContainer>
          <TextField
            InputProps={{
              readOnly: true,
            }}
            name="coupon_name"
            label="쿠폰명"
            size="small"
            sx={{
              width: "260px",
            }}
            autoComplete="off"
            value={coupon_name}
          ></TextField>
          <Box sx={{ ml: 1 }}>
            <Button
              variant="contained"
              onClick={() => {
                setOpenCouponDialog(true);
              }}
            >
              조회
            </Button>
          </Box>
        </CouponContainer>

        {/* 고객명 */}
        <Box sx={{mt:1}}>
          <TextField
            InputProps={{
              readOnly: true,
            }}
            name="mb_name"
            label="고객명"
            size="small"
            sx={{
              width: "260px",
            }}
            autoComplete="off"
            value={mb_name}
          ></TextField>
        </Box>        

        <Box
          sx={{
            mt: 5, textAlign: "center" 
          }}
        >
          <Button variant="contained" onClick={()=>onSubmit()}>
            등록완료
          </Button>
          <Button
            variant="contained"
            color="warning"
            css={css`
              margin-left: 10px;
            `}
            onClick={() => onCloseAddPop()}
          >
            취소
          </Button>
        </Box>
      </Container>
    </Box>
  );
}

export default OrderAdd;
